import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts';

interface ProtectedRouteProps {
	children: React.ReactNode;
	isAdmin?: boolean;
}

const ProtectedRoute = ({ children, isAdmin }: ProtectedRouteProps) => {
	const { authenticated, user } = useAuth();
	if (authenticated === undefined) return <p>Loading...</p>;
	if (!authenticated || (isAdmin && !user?.isAdmin)) {
		return <Navigate to="/" replace />;
	}
	return <>{children}</>;
};

export default ProtectedRoute;
